/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var BooksLibraryIcon24Solid = forwardRef('BooksLibraryIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M12 4.5A1.5 1.5 0 0 1 13.5 3h2A1.5 1.5 0 0 1 17 4.5v15a1.5 1.5 0 0 1-1.5 1.5h-2a1.5 1.5 0 0 1-1.5-1.5v-15Z" }),
        React.createElement("path", { d: "M18 4.5A1.5 1.5 0 0 1 19.5 3h2A1.5 1.5 0 0 1 23 4.5v15a1.5 1.5 0 0 1-1.5 1.5h-2a1.5 1.5 0 0 1-1.5-1.5v-15Z" }),
        React.createElement("path", { d: "M8.494 3.634a1.5 1.5 0 0 0-1.994.725L.161 17.954a1.5 1.5 0 0 0 .726 1.993l1.812.846a1.5 1.5 0 0 0 1.994-.726l6.339-13.595a1.5 1.5 0 0 0-.726-1.993l-1.812-.845Z" })));
});
